import { memo } from "react";
import { Link } from "react-router-dom";
import CarouselTransition from "./CarouselTransition";

const Hero = () => {
  return (
    <section className="h-[60vh] flex flex-col lg:flex-row items-stretch gap-4 px-4 sm:px-6 lg:px-0 py-6 lg:py-5 mx-auto lg:container">
      {/* Carousel */}
      <div className="w-full lg:w-11/12  rounded-lg overflow-hidden">
        <CarouselTransition />
      </div>

      {/* Welcome Section */}
      <div className="w-full lg:w-2/5 bg-white dark:bg-gray-800 rounded-lg p-6 sm:p-10 flex flex-col items-center justify-center text-center gap-4">
        <h1 className="text-gray-800 dark:text-white font-bold text-2xl sm:text-3xl lg:text-4xl leading-tight">
          Bienvenue sur
          <span className="block text-primary mt-2">Moide-Ferme !</span>
        </h1>

        <p className="text-gray-600 dark:text-gray-300 text-base sm:text-lg leading-relaxed max-w-md">
          Passionné par l'agriculture et les animaux de la ferme ? Découvrez nos
          conseils et astuces pour créer votre ferme et prendre soin de vos
          animaux.
        </p>

        <Link
          to="/contact"
          className="inline-block bg-primary hover:bg-primary/90 text-white font-medium py-3 px-8 rounded-lg transition-colors duration-200 mt-2"
        >
          Nous contacter
        </Link>
      </div>
    </section>
  );
};

export default memo(Hero);
